export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7871.f07262a8.jpg";